import { OptionsObject, useSnackbar } from "notistack";
import { useEffect, useRef, useState } from "react";
import { Bar, getElementsAtEvent } from "react-chartjs-2";
import { getRelatedKeywords } from "../../../api/statistics/keyword/KeywordStatisticsAPI";
import { AlertErrorProp } from "../../../components/SnackbarNoti";
import { Chart, registerables } from "chart.js";
import { horizontalChartOptions } from "../../../util/ChartStyleUtil";
import { singleField } from "../../../util/ArrayUtil";
import { findContentFlexFilter } from "../../../api/content/ContentAPI";
import ContentListPopup from "../../../components/popup/ContentListPopup";
import { useTranslation } from "react-i18next";
import { errorNoti } from "../../../util/SnackbarMessage";
Chart.register(...registerables);

type KeywordTimeProps = {
  keyword: string;
  time: number;
};

function RelatedKeywordChartWrapper(props: KeywordTimeProps) {
  const [keywordData, setKeywordData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [popup, setPopup] = useState(false);
  const [sources, setSources] = useState([]);
  const [adjacentKeyword, setAdjacentKeyword] = useState("");
  const { t } = useTranslation(["common", "error"]);
  const chartRef = useRef();
  const onClosePopup = () => {
    setPopup(false);
    setSources([]);
  };
  useEffect(() => {
    getRelatedKeywords(props.keyword, props.time)
      .then((res) => {
        setKeywordData(res);
      })
      .catch(() =>
        enqueueSnackbar(
          t("common:load_failed_message"),
          AlertErrorProp as OptionsObject
        )
      );
  }, [props.keyword, props.time]);
  useEffect(() => {
    if (adjacentKeyword.length > 0) {
      findContentFlexFilter({
        keyword: props.keyword,
        days: props.time,
        adjacentKeyword: adjacentKeyword.toString(),
      })
        .then((res) => setSources(res))
        .catch((err) => {
          var noti = errorNoti(err);
          enqueueSnackbar(t("error:" + noti.message), noti.option);
        });
    }
  }, [adjacentKeyword]);

  const onClick = (event: any) => {
    if (
      getElementsAtEvent(chartRef.current as unknown as Chart, event).length > 0
    ) {
      const index = getElementsAtEvent(
        chartRef.current as unknown as Chart,
        event
      )[0].index;
      setPopup(true);
      var keyword = keywordData[index];
      setAdjacentKeyword(keyword["keyword"]);
    }
  };
  const labels = singleField(keywordData, "keyword");
  const datas = singleField(keywordData, "count");
  const colors = labels.map(function (row) {
    if (String(row).toLowerCase() == props.keyword.toLowerCase()) {
      return "red";
    } else return "#48B0F7";
  });
  var options = horizontalChartOptions();
  options.plugins.title.text =
    "Các từ khóa liên quan đến " +
    props.keyword +
    " (" +
    props.time +
    " ngày gần nhất)";
  options.plugins.title.display = true;
  return (
    <div>
      <Bar
        data={{
          labels: labels,
          datasets: [
            {
              label: "Số lần xuất hiện",
              backgroundColor: colors,
              data: datas,
            },
          ],
        }}
        options={options}
        onClick={onClick}
        ref={chartRef}
      />
      <ContentListPopup
        popup={popup}
        onClosePopup={onClosePopup}
        contents={sources}
        title={
          "Các bài báo gần đây về " + props.keyword + " và " + adjacentKeyword
        }
      />
    </div>
  );
}

export default RelatedKeywordChartWrapper;
